'use client';
import { SearchIndexCourseFilters } from '@shared/types';
import { FunctionComponent, useCallback, useState } from 'react';
import { CourseCourseSearch } from '../../../../../../components/EducatorCourseSearch';
import { SearchError } from '../../../../../../components/EducatorCourseSearch/SearchError';
import { CourseResults } from '../../../../../../components/EducatorCourseSearch/CourseResults';
import { LoadMoreButton } from '../../../../../../components/EducatorCourseSearch/LoadMoreButton';
import { SearchIndexSortBy } from '../../../../../../services/search/shared';
import { useCourseSearchProps } from '../../../../../../services/search/course/useCourseSearch';
import { SearchBar } from '../../../../../../components/EducatorCourseSearch/SearchBar';
import { PublicEducator } from '@cademy-package/sdk-component-types';

type CoursesProps = {
    listId: string;
    layout: 'grid' | 'rows' | 'datedRows';
    initialResults?: NonNullable<useCourseSearchProps['initialResults']>;
    sort?: SearchIndexSortBy;
    perPage: number;
    educator?: PublicEducator;
};
export const Courses: FunctionComponent<CoursesProps> = ({
    listId,
    layout,
    initialResults,
    sort,
    perPage,
    educator,
}) => {
    const [filters, _setFilters] = useState<SearchIndexCourseFilters>({
        context: 'minisite',
        list_refs: [listId],
    });
    const setFilters = useCallback(
        (filters: SearchIndexCourseFilters) => {
            _setFilters({ ...filters, list_refs: [listId] });
        },
        [listId]
    );
    const [search, setSearch] = useState('');

    return (
        <CourseCourseSearch
            filters={filters}
            setFilters={setFilters}
            searchTerm={search || ''}
            setSearchTerm={setSearch}
            initialResults={initialResults}
            perPage={perPage}
        >
            <SearchBar />
            <SearchError />
            <CourseResults displayAs={layout} educator={educator} />
            <LoadMoreButton />
            <SearchError />
        </CourseCourseSearch>
    );
};
